import { Actions as PAYROLL_ACTIONS } from "./payrollActions";

import { createRequest } from "@/components/common/helpers/RequestHelpers";
import { NotificationManager } from "react-notifications";
import apiURL from "./apiURL";

const request = createRequest({
	urlPath: "/settings/",
	// local: true,
});

const Types = {
	ALLOWANCE_UPDATE_LIST: "ALLOWANCE_UPDATE_LIST",
	ALLOWANCES_UPLOADING: "ALLOWANCES_UPLOADING",
	ALLOWANCES_UPLOADED: "ALLOWANCES_UPLOADED",
	ALLOWANCES_ADD: "ALLOWANCES_ADD",
	ALLOWANCES_CLEAR: "ALLOWANCES_CLEAR",
	ALLOWANCES_ADVISOR_ADD: "ALLOWANCES_ADVISOR_ADD",
	ALLOWANCE_GOVT_BONUS_UPDATE_LIST: "ALLOWANCE_GOVT_BONUS_UPDATE_LIST",
	ALLOWANCES_UPDATE_FIELD: "ALLOWANCES_UPDATE_FIELD",
	ALLOWANCES_ADVISOR_UPDATE_FIELD: "ALLOWANCES_ADVISOR_UPDATE_FIELD",
	ALLOWANCES_APPLY_TEMPLATE: "ALLOWANCES_APPLY_TEMPLATE",
};

const updateSetting = (id, field, newValue, newCompany) => ({
	type: Types.ALLOWANCES_UPDATE_FIELD,
	id,
	field,
	newValue,
	newCompany,
});

const updateAdvisorSetting = (id, field, newValue) => ({
	type: Types.ALLOWANCES_ADVISOR_UPDATE_FIELD,
	id,
	field,
	newValue,
});

const bonusUpdateList = (response) => ({
	type: Types.ALLOWANCE_GOVT_BONUS_UPDATE_LIST,
	payload: response,
});

const govtBonusGetList = (year) => {
	return (dispatch, getState) => {
		fetch(apiURL + `/settings/governmentBonuses/${year}`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log("entity data", data);
				dispatch(bonusUpdateList(data));
			});
	};
};

const allowanceUpdateList = (response) => ({
	type: Types.ALLOWANCE_UPDATE_LIST,
	payload: response,
});

const allowanceGetList = () => {
	return (dispatch, getState) => {
		request({
			path: `allowances`,
			method: "GET",
		})
			.then(({ data }) => {
				dispatch(allowanceUpdateList(data));
			})
			.catch((err) => {
				console.error(err);
				NotificationManager.error("Error", "Error loading allowances");
			});
	};
};

const addAllowance = (parent, newCompany, id) => ({
	type: Types.ALLOWANCES_ADD,
	parent,
	newCompany,
	id,
});

const clearAllowance = (newCompany) => ({
	type: Types.ALLOWANCES_CLEAR,
	newCompany,
});

const addAdvisorAllowance = () => ({
	type: Types.ALLOWANCES_ADVISOR_ADD,
});

const uploadingAllowances = (progress) => ({
	type: Types.ALLOWANCES_UPLOADING,
	progress,
});

const allowancesUploaded = (payload) => ({
	type: Types.ALLOWANCES_UPLOADED,
	payload,
});

const allowancesApplyTemplate = (template) => ({
	type: Types.ALLOWANCES_APPLY_TEMPLATE,
	template,
});

const uploadPayrollAllowances = ({
	file,
	companyPayPeriod,
	periodStartDate,
	periodEndDate,
	casualStartDate,
	casualEndDate,
	payDate,
	appendIfExists,
}) => {
	return (dispatch, getState) => {
		const state = getState();

		dispatch(uploadingAllowances("0%"));

		const formData = new FormData();

		formData.append("companyPayPeriod", companyPayPeriod);
		formData.append("periodStartDate", periodStartDate);
		formData.append("periodEndDate", periodEndDate);
		formData.append("casualStartDate", casualStartDate);
		formData.append("casualEndDate", casualEndDate);
		formData.append("payDate", payDate);
		formData.append("appendIfExists", appendIfExists);

		formData.append("file", file); // appending file

		request({
			path: `upload/payrollAllowances`,
			method: "POST",
			body: formData,
			onUploadProgress: (ProgressEvent) => {
				let progress = Math.round((ProgressEvent.loaded / ProgressEvent.total) * 100) + "%";
				dispatch(uploadingAllowances(progress));
			},
		})
			.then((res) => {
				// console.log('allowances processed',res.data.results);
				dispatch(allowancesUploaded(res.data.results));

				dispatch(PAYROLL_ACTIONS.payrollGetList(state.payroll.payPeriodDetails.id));
			})
			.catch((err) => {
				console.error(err);
				dispatch(allowancesUploaded({}));
				NotificationManager.error("Error uploading allowances", "Upload Allowances");
			});
	};
};
/*const selectTrackingCategory = trackingCategory => ({
  type: Types.SELECT_TRACKING_CATEGORY,
  trackingCategory: trackingCategory
});

const selectYear = year => ({
  type: Types.SELECT_YEAR,
  year
});

const updateFacilities = response => ({
  type: Types.GET_FACILITIES,
  payload: response
});

const getFacilities = () => {
  return (dispatch, getState) => {

    fetch(apiURL + `/my/facilities` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Organisation': getState().currentOrganisation,
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(updateFacilities(data))
    })
  }
}*/

const Actions = {
	allowanceGetList,
	uploadPayrollAllowances,
	addAllowance,
	clearAllowance,
	addAdvisorAllowance,
	govtBonusGetList,
	updateSetting,
	updateAdvisorSetting,
	allowancesUploaded,
	allowancesApplyTemplate,
};

// exports = {
//   Types,
//   Actions
// }

export { Actions, Types };

// exports.Types = Types
// exports.Actions = Actions
